import React from 'react';

const CircularProgress = ({ percentage }) => {
    const radius = 46;
    const stroke = 4;
    const normalizedRadius = radius - stroke * 2;
    const circumference = normalizedRadius * 2 * Math.PI;
    const strokeDashoffset = circumference - (percentage / 100) * circumference;

    return (
        <div className='relative flex items-center justify-center w-24 h-24 mt-auto'>
            <svg height={radius * 2} width={radius * 2} className='absolute top-0 left-0'>
                <circle
                    stroke='#E4D6D6'
                    fill='transparent'
                    strokeWidth={stroke}
                    r={normalizedRadius}
                    cx={radius}
                    cy={radius}
                />
                <circle
                    stroke='#D47554'
                    fill='transparent'
                    strokeWidth={stroke}
                    strokeDasharray={circumference + ' ' + circumference}
                    style={{ strokeDashoffset }}
                    strokeLinecap='round'
                    r={normalizedRadius}
                    cx={radius}
                    cy={radius}
                    className='transition-all duration-300 ease-in-out'
                />
            </svg>
            <div className='text-2xl font-bold text-[#D47554]'>{percentage}%</div>
        </div>
    );
};

export default CircularProgress;
